import './style.css';

import LoadingSpinner from 'bz-core-controls/controls/layout/loading-spinner';
import _ from 'lodash';
import React from 'react';
import { Entity } from 'tm2-draft-js';

class Toolbox extends React.Component {
  render() {
    let { mode, controls } = this.props.store;
    if (mode === 'live') {
      return <span />;
    }
    if (_.isEmpty(controls)) {
      return (
        <div>
          <LoadingSpinner active={true} />
        </div>
      );
    }

    let ctrls = Object.keys(controls).map((x, i) => {
      let ctrl = controls[x];
      let className = `fa ${ctrl.icon || 'fa-question-circle-o'}`;
      return (
        <div key={i} className="tool">
          <div
            draggable="true"
            onDragStart={this.onDragStart.bind(this, x)}
            onTouchStart={this.onTouchStart.bind(this, x)}
          >
            <i className={className} />
            <span>{ctrl.tag || x}</span>
          </div>
        </div>
      );
    });

    return (
      <div className="toolbox">
        <div className="tools">
          {ctrls}
          <div className="tool">
            <div
              draggable="true"
              onDragStart={this.onGroup}
              onTouchStart={this.onGroupStart.bind(this)}
            >
              <i className="fa fa-question-circle-o" />
              <span>Group</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onGroup(e) {
    let entityKey = Entity.create('Group', 'MUTABLE', {});
    e.dataTransfer.setData('text', entityKey);
    e.dataTransfer.setData('insert', entityKey);
  }

  onGroupStart() {
    let { store } = this.props;
    let entityKey = Entity.create('Group', 'MUTABLE', {});
    store.insertGroup(entityKey, store.editor.getSelection());
  }

  onTouchStart(key, e) {
    let { store } = this.props;
    let { controls } = store;
    let schema = controls[key];
    let type = schema.type;
    let attrs = schema.attributes || [];

    let res;
    if (key === 'Label') {
      res = { field: '' };
    } else if (key === 'DateTimePicker') {
      res = { field: '', label: '', required: false };
    } else {
      res = { field: '', label: '', required: false, inline: false };
    }
    attrs.map((a) => {
      res[a] = null;
    });

    let entityKey = Entity.create(`Control-${key}`, 'IMMUTABLE', res);

    store.insertControl(entityKey, store.editor.getSelection());
    return true;
  }

  onDragStart(key, e) {
    let { controls } = this.props.store;
    let schema = controls[key];
    let type = schema.type;
    let attrs = schema.attributes || [];

    let res;
    if (key === 'Label') {
      res = { field: '' };
    } else if (key === 'DateTimePicker') {
      res = { field: '', label: '', required: false };
    } else {
      res = { field: '', label: '', required: false, inline: false };
    }

    attrs.map((a) => {
      res[a] = null;
    });

    let entityKey = Entity.create(`Control-${key}`, 'IMMUTABLE', res);
    e.dataTransfer.setData('text', entityKey);
    e.dataTransfer.setData('insert', entityKey);
  }
}

export default Toolbox;
